// Libraries
import { Flex, Grid, Text, Tooltip } from '@chakra-ui/react';
// Components
import { PillList } from '@organisms/index';
import { ClearFiltersButton } from '@molecules/index';
// Utils
import text from '@translations/en.json';
// Types
import { CardTableHeaderProps } from './CardTableHeader.types';
import { QuestionOutlineIcon } from '@chakra-ui/icons';

/**
 * A reusable component that represents the header of a table.
 *
 * @param {CardTableHeaderProps<TableBody>} props - The props for the CardTableHeader component.
 * @param {Table<TableBody>} props.table - The table instance that holds the data and filters.
 *
 * @returns {ReactElement} JSX element representing the CardTableHeader.
 */
export const CardTableHeader = <TableBody,>({
  table,
  label = text.vessels,
  tooltip,
}: CardTableHeaderProps<TableBody>) => {
  const { getGlobalFacetedRowModel, getState, setColumnFilters } = table;
  const { columnFilters } = getState();

  return (
    <Grid alignItems='center' gap={2} gridTemplateColumns='auto 1fr auto'>
      <Flex alignItems='center'>
        <Text fontSize='hs' h={14} lineHeight='base' fontWeight='medium' p={3}>
          {getGlobalFacetedRowModel().rows.length} {label}
        </Text>
        {!!tooltip && (
          <Tooltip
            hasArrow
            placement='top'
            openDelay={100}
            closeDelay={200}
            gutter={12}
            bg='white'
            label={
              <Text fontSize='s' p={1}>
                {tooltip}
              </Text>
            }
          >
            <QuestionOutlineIcon
              transition='all 0.2s ease-in-out'
              color='grey.100'
              boxSize={3}
              _hover={{
                color: 'base',
              }}
            />
          </Tooltip>
        )}
      </Flex>
      <PillList setColumnFilters={setColumnFilters} columnFilters={columnFilters} />
      <ClearFiltersButton columnFiltersLength={columnFilters.length} setColumnFilters={setColumnFilters} />
    </Grid>
  );
};
